import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faUser,
  faCalendarAlt,
  faFilter,
  faTools,
  faCogs,
  faCommentAlt,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { URL } from "../../../config";
import "./filterOrderForm.css";
import { useNavigate } from "react-router-dom";

// const API_BASE = "http://localhost:4001";

const FilterOrderForm = ({ onClose, onSubmit, formData, user, previousServitorName, serviceId}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // lists from API
  const [divisions, setDivisions] = useState([]); // [{Id,name,code}]
  const [areas, setAreas] = useState([]);         // [{Id,name}]

  // selected ids
  const [selectedDivisionId, setSelectedDivisionId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);

  const [orderData, setOrderData] = useState({
    // city: user?.city || formData.City || "",
    address: user?.Address || formData.Address || "",
    mobile: user?.mobile || "",
  });
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [showBlockedPopup, setShowBlockedPopup] = useState(false);
  // const [serviceId, setServiceId] = useState(null);

  const [errors, setErrors] = useState({ city: "", area: "", address: "" });

  // For coupons
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const areaRef = useRef(null);
  const divisionRef = useRef(null);
  const addressRef = useRef(null);

  const penalty = user && user.penalty ? Number(user.penalty) : 0;
  const basePrice = Number(formData.price) || 0;
  // const finalPrice = user && user.penaltyReserved ? basePrice : basePrice + penalty;

  const [discountValue, setDiscountValue] = useState(0);
  
  const finalPrice = (() => {
    const total = user.penaltyReserved ? basePrice : basePrice + penalty;
    return Math.max(0, total - discountValue);
  })();

  useEffect(() => {
    if (user) {
      if (user.status === "Blocked") {
        setShowBlockedPopup(true);
        setShowForm(false);
      } else {
        setOrderData({
          city: user.city || formData.City || "",
          address: user.Address || formData.Address || "",
          mobile: user.mobile || "",
        });
      }
    }
  }, [user, formData.City, formData.Address]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  // useEffect(() => {
  //   const fetchServiceId = async () => {
  //     try {
  //       const { data } = await axios.get(`${URL}/services`);
  //       const found = data.find((s) => s.services_name.toLowerCase() === "filter service");
  //       if (found) setServiceId(found.Id);
  //     } catch (error) {
  //       console.error("Error fetching service ID:", error);
  //     }
  //   };
  //   fetchServiceId();
  // }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setOrderData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };

  useEffect(() => {
  (async () => {
    try {
      const { data } = await axios.get(`${URL}/locations/divisions`, { params: { countryCode: "BD" } });
      setDivisions(data || []);
      if (user?.city) {
        const match = (data || []).find(d => d.name.toLowerCase() === String(user.city).toLowerCase());
        if (match) setSelectedDivisionId(match.Id);
      }
    } catch (e) {
      console.error("Failed to load divisions:", e);
      setDivisions([]);
    }
  })();
}, [user?.city]);


useEffect(() => {
  (async () => {
    if (!selectedDivisionId) {
      setAreas([]);
      setSelectedAreaId(null);
      return;
    }
    try {
      const { data } = await axios.get(`${URL}/locations/areas`, { params: { divisionId: selectedDivisionId } });
      setAreas(data || []);
      if (user?.area) {
        const match = (data || []).find(a => a.name.toLowerCase() === String(user.area).toLowerCase());
        setSelectedAreaId(match ? match.Id : null);
      } else {
        setSelectedAreaId(null);
      }
    } catch (e) {
      console.error("Failed to load areas:", e);
      setAreas([]);
      setSelectedAreaId(null);
    }
  })();
}, [selectedDivisionId, user?.area]);


const clearError = (key) => setErrors(e => ({ ...e, [key]: "" }));

const handleDivisionChange = (e) => {
  const id = e.target.value ? Number(e.target.value) : null;
  setSelectedDivisionId(id);
  clearError("city");
};

const handleAreaChange = (e) => {
  const id = e.target.value ? Number(e.target.value) : null;
  setSelectedAreaId(id);
  clearError("area");
};

const handleAddressChange = (e) => {
  setOrderData(prev => ({ ...prev, address: e.target.value }));
  if (e.target.value?.trim()) clearError("address");
};

const validate = () => {
  const next = {};
  if (!selectedDivisionId) next.city = t("Please select your city");
  if (!selectedAreaId)     next.area = t("Please select your area");
  if (!orderData.address?.trim()) next.address = t("Please provide your address");
  setErrors(next);
  return Object.keys(next).length === 0;
};




  const formatDate = (dateStr) => {
    const dateObj = new Date(dateStr);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" });
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!validate()) {
      if (!selectedDivisionId && divisionRef.current) {
        divisionRef.current.focus();
        divisionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!selectedAreaId && areaRef.current) {
        areaRef.current.focus();
        areaRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!orderData.address?.trim() && addressRef.current) {
        addressRef.current.focus();
        addressRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    const selectedDivision = divisions.find((d) => d.Id === selectedDivisionId);
    const selectedArea = areas.find((a) => a.Id === selectedAreaId);

    const finalOrderData = {
      userId: user.Id,

      // names (server stores City/Area/Address)
      usercity: selectedDivision?.name || "",
      userarea: selectedArea?.name || "",
      useraddress: orderData.address,

      filterType: formData.filterType,
      new_filter_setup: formData.new_filter_setup,
      installation_filter: formData.installation_filter,
      uninstallation_filter: formData.uninstallation_filter,
      kit_replacement: formData.kit_replacement,
      pipe_leak_or_replace: formData.pipe_leak_or_replace,
      full_servicing: formData.full_servicing,
      check_up: formData.check_up,
      remarks: formData.remarks,

      // send BASE price; server adds penalty
      // price: formData.price,
      price: finalPrice,

      date: formData.date,
      time: formData.time,
      status: "pending",

      // rebook (same convention as others)
      useSameServitor: formData.useSameServitor,
      previousServitorId: formData.servitor_id,
      servitor_id: formData.useSameServitor ? formData.servitor_id : 0,

      serviceId: serviceId || 6,
    };

    if (appliedCoupon) {
      finalOrderData.appliedCoupon = appliedCoupon;
      finalOrderData.discountValue = discountValue;
    }

    try {
      setIsSubmitting(true);

      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(`${URL}/filter`, finalOrderData, { headers });
      console.log("Order placed successfully:", response.data);
      setShowForm(false);
      setShowSuccessPopup(true);
    } catch (error) {
      console.error("Error placing order:", error);
    } finally {
      setIsSubmitting(false);
    }
  };


   // === Coupon handling ===
    const handleApplyCoupon = async () => {
      if (!couponCode.trim()) {
        setCouponError("Please enter a coupon code.");
        return;
      }
      setIsApplyingCoupon(true);
      setCouponError("");
      try {
        const res = await axios.post(`${URL}/usercoupon/apply`, {
          userId: user.Id,
          code: couponCode.trim(),
        });
        const { discountValue, code } = res.data;
        setAppliedCoupon(code);
        setDiscountValue(discountValue);
        setCouponError("");
      } catch (err) {
        setAppliedCoupon(null);
        setDiscountValue(0);
        setCouponError(err?.response?.data?.message || "Invalid or expired coupon.");
      } finally {
        setIsApplyingCoupon(false);
      }
    };
  
    const handleRemoveCoupon = async () => {
      // try {
      //   await axios.post(`${URL}/usercoupon/remove`, {
      //     userId: user.Id,
      //     code: appliedCoupon,
      //   });
      // } catch (err) {
      //   console.warn("Coupon removal failed (non-blocking):", err);
      // }
      setAppliedCoupon(null);
      setDiscountValue(0);
      setCouponCode("");
      setCouponError("");
    };

  const closePopup = () => {
    setShowSuccessPopup(false);
    onSubmit();
    onClose();
    navigate("/profile/orderhistory");
  };

  const closeBlockedPopup = () => {
    setShowBlockedPopup(false);
    onClose();
  };

  return (
    <>
      {showForm && (
        <div className="filterorderform-modal-backdrop">
          <div className="filterorderform-modal-content">
            <div className="filterorderform-modal-header">
              <h2 className="filterorderform-modal-title">
                {t("filterorderform.order_form.modal.title")}
              </h2>
              <button
                className="filterorderform-modal-close"
                onClick={onClose}
                aria-label={t("filterorderform.order_form.modal.close_button")}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="filterorderform-modal-body">
              <div className="filterorderform-two-column-grid">
                <div className="filterorderform-modal-card">
                  <div className="filterorderform-card-body">
                    <h3 className="filterorderform-card-title">
                      <FontAwesomeIcon icon={faUser} />
                      {t("filterorderform.order_form.customer_information.title")}
                    </h3>
                    <div className="filterorderform-form-grid">
                      <div className="filterorderform-form-group">
                        <label className="filterorderform-form-label">
                          {t("filterorderform.order_form.customer_information.labels.name")}
                        </label>
                        <input
                          type="text"
                          className="filterorderform-form-control"
                          value={`${user.FirstName} ${user.LastName}`}
                          readOnly
                        />
                      </div>
                      <div className="filterorderform-form-group">
                        <label className="filterorderform-form-label">
                          {t("filterorderform.order_form.customer_information.labels.mobile")}
                        </label>
                        <input
                          type="text"
                          className="filterorderform-form-control"
                          value={orderData.mobile ? `${orderData.mobile}` : ""}
                          readOnly
                        />
                      </div>
                      <div className="filterorderform-form-group">
                        <label className="filterorderform-form-label">
                          {t("filterorderform.order_form.customer_information.labels.city")}
                        </label>
                        <select
                          className="filterorderform-form-control"
                          value={selectedDivisionId || ""}
                          onChange={handleDivisionChange}
                          onBlur={validate}
                          aria-invalid={Boolean(errors.city)}
                          aria-describedby={errors.city ? "city-error" : undefined}
                          ref={divisionRef}
                        >
                          <option value="">
                            {t("plumberorderform.order_form.customer_information.labels.city_placeholder")}
                          </option>
                          {divisions.map(d => (
                            <option key={d.Id} value={d.Id}>{d.name}</option>
                          ))}
                        </select>
                        {errors.city && <div id="city-error" className="field-error">{errors.city}</div>}
                      </div>

                      {/* Area */}
                      <div className="filterorderform-form-group">
                        <label className="filterorderform-form-label">
                          {t("electricianorderform.order_form.customer_information.labels.area", "Area")}
                        </label>
                        <select
                          className="filterorderform-form-control"
                          value={selectedAreaId || ""}
                          onChange={handleAreaChange}
                          onBlur={validate}
                          disabled={!selectedDivisionId}
                          aria-invalid={Boolean(errors.area)}
                          aria-describedby={errors.area ? "area-error" : undefined}
                          ref={areaRef}
                        >
                          <option value="">
                            {!selectedDivisionId ? t("Select City first") : t("Select Area")}
                          </option>
                          {areas.map(a => (
                            <option key={a.Id} value={a.Id}>{a.name}</option>
                          ))}
                        </select>
                        {errors.area && <div id="area-error" className="field-error">{errors.area}</div>}
                      </div>

                      <div className="filterorderform-form-group">
                        <label className="filterorderform-form-label">
                          {t("filterorderform.order_form.customer_information.labels.address")}
                        </label>
                        <textarea
                          name="address"
                          className="filterorderform-form-control"
                          rows="3"
                          value={orderData.address}
                          onChange={handleAddressChange}
                          onBlur={validate}
                          aria-invalid={Boolean(errors.address)}
                          aria-describedby={errors.address ? "address-error" : undefined}
                          ref={addressRef}
                        />
                        {errors.address && <div id="address-error" className="field-error">{errors.address}</div>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="filterorderform-modal-card">
                  <div className="filterorderform-card-body">
                    <h3 className="filterorderform-card-title">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                      {t("filterorderform.order_form.booking_details.title")}
                    </h3>
                    <div className="filterorderform-form-grid">
                      <div className="filterorderform-form-group">
                        <label className="filterorderform-form-label">
                          {t("filterorderform.order_form.booking_details.labels.date")}
                        </label>
                        <input
                          type="text"
                          className="filterorderform-form-control"
                          value={formatDate(formData.date)}
                          readOnly
                        />
                      </div>
                      <div className="filterorderform-form-group">
                        <label className="filterorderform-form-label">
                          {t("filterorderform.order_form.booking_details.labels.time")}
                        </label>
                        <input
                          type="text"
                          className="filterorderform-form-control"
                          value={formData.time}
                          readOnly
                        />
                      </div>
                      {!user?.penaltyReserved && penalty > 0 ? (
                        <>
                          <div className="filterorderform-form-group">
                            <label className="filterorderform-form-label">
                              {t("filterorderform.order_form.booking_details.labels.base_price")}
                            </label>
                            <input
                              type="text"
                              className="filterorderform-form-control"
                              value={`${basePrice} ${t("filterorderform.order_form.currency")}`}
                              readOnly
                            />
                          </div>
                          <div className="filterorderform-form-group">
                            <label className="filterorderform-form-label">
                              {t("filterorderform.order_form.booking_details.labels.penalty")}
                            </label>
                            <input
                              type="text"
                              className="filterorderform-form-control filterorderform-penalty-field"
                              value={`${penalty} ${t("filterorderform.order_form.currency")}`}
                              readOnly
                            />
                          </div>
                          <div className="filterorderform-form-group">
                            <label className="filterorderform-form-label">
                              {t("filterorderform.order_form.booking_details.labels.total_price")}
                            </label>
                            <input
                              type="text"
                              className="filterorderform-form-control filterorderform-total-price"
                              value={`${finalPrice} ${t("filterorderform.order_form.currency")}`}
                              readOnly
                            />
                          </div>
                        </>
                      ) : (
                        // <div className="filterorderform-form-group">
                        //   <label className="filterorderform-form-label">
                        //     {t("filterorderform.order_form.booking_details.labels.total_price")}
                        //   </label>
                        //   <input
                        //     type="text"
                        //     className="filterorderform-form-control filterorderform-total-price"
                        //     value={`${finalPrice} ${t("filterorderform.order_form.currency")}`}
                        //     readOnly
                        //   />
                        // </div>

                        // New design for dicount
                        <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.total_price")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-price-discounted">
                            <div className="electricianorder-original-price">
                              {user.penaltyReserved
                                ? `${basePrice} tk`
                                : `${basePrice + penalty} tk`}
                            </div>

                            <div className="electricianorder-final-price">
                              <span className="discounted-price">{finalPrice} tk</span>
                              <small className="discount-label">({discountValue} tk off)</small>
                            </div>
                          </div>
                        ) : (
                          <input
                            type="text"
                            className="electricianorder-form-control electricianorder-total-price"
                            value={`${finalPrice} tk`}
                            readOnly
                          />
                        )}
                      </div>

                      )}


                      {/* Coupon Code */}
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.coupon", "Coupon Code")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-coupon-applied">
                            {/* <p>
                              ✅ Applied: <strong>{appliedCoupon}</strong>
                            </p> */}
                             <p>
                                ✅ {t("electricianorderform.coupon.applied", "Applied")}:{" "}
                                <strong>{appliedCoupon}</strong>
                              </p>
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-outline"
                              className="electricianorder-btn-removecoupon"
                              onClick={handleRemoveCoupon}
                            >
                              {/* Remove */}
                              {t("electricianorderform.coupon.remove", "Remove")}
                            </button>
                          </div>
                        ) : (
                          <div className="electricianorder-coupon-input-row">
                            <input
                              type="text"
                              value={couponCode}
                              onChange={(e) => setCouponCode(e.target.value)}
                              placeholder={t("electricianorderform.order_form.booking_details.labels.coupon_placeholder", "Enter coupon")}
                              className="electricianorder-form-control"
                              disabled={isApplyingCoupon}
                            />
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-primary"
                              className="electricianorder-btn-applycoupon"
                              onClick={handleApplyCoupon}
                              disabled={isApplyingCoupon}
                            >
                              {/* {isApplyingCoupon ? "Applying..." : "Apply"} */}
                              {isApplyingCoupon
                                ? t("electricianorderform.coupon.applying", "Applying...")
                                : t("electricianorderform.coupon.apply", "Apply")}
                            </button>
                          </div>
                        )}

                        {/* {couponError && <div className="field-error">{couponError}</div>} */}

                        {couponError && (
                          <div className="field-error">
                            {t("electricianorderform.coupon.invalid", couponError)}
                          </div>
                        )}

                      </div>

                      
                    </div>
                  </div>
                </div>
              </div>

              <div className="filterorderform-modal-card">
                <div className="filterorderform-card-body">
                  <h3 className="filterorderform-card-title">
                    {/* <FontAwesomeIcon icon={faTools} /> */}
                    {t("filterorderform.order_form.service_details.title")}
                  </h3>
                  <div className="filterorderform-services-section">
                    <div className="filterorderform-service-category">
                      <h4 className="filterorderform-category-header">
                        <FontAwesomeIcon icon={faFilter} />
                        {t("filterorderform.order_form.service_details.categories.filter_specifications.title")}
                      </h4>
                      <div className="filterorderform-services-grid">
                        <div className="filterorderform-service-item">
                          <label className="filterorderform-form-label">
                            {t("filterorderform.order_form.service_details.categories.filter_specifications.labels.filter_type")}
                          </label>
                          <div
                            className={`filterorderform-service-value ${formData.filterType ? "has-value" : ""}`}
                          >
                            {formData.filterType || "-"}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="filterorderform-service-category">
                      <h4 className="filterorderform-category-header">
                        <FontAwesomeIcon icon={faTools} />
                        {t("filterorderform.order_form.service_details.categories.setup_services.title")}
                      </h4>
                      <div className="filterorderform-services-grid">
                        <div className="filterorderform-service-item">
                          <label className="filterorderform-form-label">
                            {t("filterorderform.order_form.service_details.categories.setup_services.labels.new_filter_setup")}
                          </label>
                          <div
                            className={`filterorderform-service-value ${formData.new_filter_setup > 0 ? "has-value" : ""}`}
                          >
                            {formData.new_filter_setup}{" "}
                            <span className="filterorderform-service-unit">
                              {t(formData.new_filter_setup === 1 ? "filterorderform.order_form.service_details.unit" : "filterorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                        <div className="filterorderform-service-item">
                          <label className="filterorderform-form-label">
                            {t("filterorderform.order_form.service_details.categories.setup_services.labels.installation_filter")}
                          </label>
                          <div
                            className={`filterorderform-service-value ${formData.installation_filter > 0 ? "has-value" : ""}`}
                          >
                            {formData.installation_filter}{" "}
                            <span className="filterorderform-service-unit">
                              {t(formData.installation_filter === 1 ? "filterorderform.order_form.service_details.unit" : "filterorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                        <div className="filterorderform-service-item">
                          <label className="filterorderform-form-label">
                            {t("filterorderform.order_form.service_details.categories.setup_services.labels.uninstallation_filter")}
                          </label>
                          <div
                            className={`filterorderform-service-value ${formData.uninstallation_filter > 0 ? "has-value" : ""}`}
                          >
                            {formData.uninstallation_filter}{" "}
                            <span className="filterorderform-service-unit">
                              {t(formData.uninstallation_filter === 1 ? "filterorderform.order_form.service_details.unit" : "filterorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="filterorderform-service-category">
                      <h4 className="filterorderform-category-header">
                        <FontAwesomeIcon icon={faCogs} />
                        {t("filterorderform.order_form.service_details.categories.maintenance_services.title")}
                      </h4>
                      <div className="filterorderform-services-grid">
                        <div className="filterorderform-service-item">
                          <label className="filterorderform-form-label">
                            {t("filterorderform.order_form.service_details.categories.maintenance_services.labels.kit_replacement")}
                          </label>
                          <div
                            className={`filterorderform-service-value ${formData.kit_replacement > 0 ? "has-value" : ""}`}
                          >
                            {formData.kit_replacement}{" "}
                            <span className="filterorderform-service-unit">
                              {t(formData.kit_replacement === 1 ? "filterorderform.order_form.service_details.unit" : "filterorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                        <div className="filterorderform-service-item">
                          <label className="filterorderform-form-label">
                            {t("filterorderform.order_form.service_details.categories.maintenance_services.labels.pipe_leak_or_replace")}
                          </label>
                          <div
                            className={`filterorderform-service-value ${formData.pipe_leak_or_replace > 0 ? "has-value" : ""}`}
                          >
                            {formData.pipe_leak_or_replace}{" "}
                            <span className="filterorderform-service-unit">
                              {t(formData.pipe_leak_or_replace === 1 ? "filterorderform.order_form.service_details.unit" : "filterorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                        <div className="filterorderform-service-item">
                          <label className="filterorderform-form-label">
                            {t("filterorderform.order_form.service_details.categories.maintenance_services.labels.full_servicing")}
                          </label>
                          <div
                            className={`filterorderform-service-value ${formData.full_servicing > 0 ? "has-value" : ""}`}
                          >
                            {formData.full_servicing}{" "}
                            <span className="filterorderform-service-unit">
                              {t(formData.full_servicing === 1 ? "filterorderform.order_form.service_details.unit" : "filterorderform.order_form.service_details.units")}
                            </span>
                          </div>
                        </div>
                        <div className="filterorderform-service-item">
                          <label className="filterorderform-form-label">
                            {t("filterorderform.order_form.service_details.categories.maintenance_services.labels.check_up")}
                          </label>
                          <div
                            className={`filterorderform-service-value ${formData.check_up ? "boolean-true" : ""}`}
                          >
                            {t(`filterorderform.order_form.service_details.boolean.${formData.check_up ? "yes" : "no"}`)}
                          </div>
                        </div>
                      </div>
                    </div>

                    {formData.useSameServitor && previousServitorName && (
                      <div className="filterorderform-service-category">
                        <div className="filterorderform-rebook-item">
                          <label className="filterorderform-label-content">
                            <FontAwesomeIcon icon={faUserCheck} className="filterorderform-rebook-icon" />
                            {t("filterorderform.order_form.rebook.label")}
                          </label>
                          <div className="filterorderform-rebook-value">
                            <strong>{previousServitorName}</strong>
                          </div>
                        </div>
                      </div>
                    )}

                    {formData.remarks && (
                      <div className="filterorderform-remarks-item">
                        <label className="filterorderform-form-label">
                          <FontAwesomeIcon icon={faCommentAlt} className="filterorderform-remarks-icon" />
                          {t("filterorderform.order_form.service_details.categories.maintenance_services.labels.remarks")}
                        </label>
                        <div className="filterorderform-remarks-value has-value">
                          {formData.remarks}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="filterorderform-order-actions">
              <button
                className="filterorderform-btn filterorderform-btn-outline"
                onClick={onClose}
              >
                {t("filterorderform.order_form.actions.cancel")}
              </button>
              <button
                className="filterorderform-btn filterorderform-btn-primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                <FontAwesomeIcon icon={faTools} />
                {/* {t("filterorderform.order_form.actions.place_order")} */}
                {isSubmitting
                  ? t("filterorderform.order_form.actions.placing", "Placing...")
                  : t("filterorderform.order_form.actions.place_order")}

              </button>
            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="filterorderform-success-popup">
          <div className="filterorderform-success-popup-content">
            <h2>{t("filterorderform.order_form.success_popup.title")}</h2>
            <p>{t("filterorderform.order_form.success_popup.message1")}</p>
            <p>{t("filterorderform.order_form.success_popup.message2")}</p>
            <button
              className="filterorderform-btn filterorderform-btn-primary"
              onClick={closePopup}
            >
              {t("filterorderform.order_form.success_popup.button")}
            </button>
          </div>
        </div>
      )}

      {showBlockedPopup && (
        <div className="filterorderform-success-popup">
          <div className="filterorderform-success-popup-content">
            <h2>{t("filterorderform.order_form.blocked_popup.title")}</h2>
            <p>{t("filterorderform.order_form.blocked_popup.message1")}</p>
            <p>{t("filterorderform.order_form.blocked_popup.message2")}</p>
            <button
              className="filterorderform-btn filterorderform-btn-primary"
              onClick={closeBlockedPopup}
            >
              {t("filterorderform.order_form.blocked_popup.button")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FilterOrderForm;